import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { get_province_rules } from '../../redux/actions/rulesAction'
import RulesDetails from './RulesDetails'
import { selectClasses } from '@mui/base'
import EditRule from './EditRule'
import { add } from 'lodash-es'
import AddProvinceRule from './AddProvinceRule'

const ListProvinceRules = () => {
    const dispatch = useDispatch()
    const { rules, isLoading } = useSelector(state => state.province_rule)
    
    const [viewModal, setViewModal] = useState(false)
    const [editModal, setEditModal] = useState(false)
    const [openAdd,setOpen] = useState(false)
    const [selectedRule, setSelectedRule] = useState(null)
    const [formData, setFormData] = useState({})

    const handleView = (rule) => {
        setSelectedRule(rule)
        setViewModal(true)
    }

    const handleEdit = (rule) => {
        setSelectedRule(rule)
        setFormData(rule)
        setEditModal(true)
    }

    const closeModals = () => {
        setViewModal(false)
        setEditModal(false)
        setSelectedRule(null)
        setOpen(false)
        setFormData({})
    }

    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target
        setFormData({
            ...formData,
            [name]: type === 'checkbox' ? checked : value
        })
    }

    const handleSave = () => {
        console.log("Saving data:", formData)
        // dispatch(updateProvinceRule(formData))
        closeModals()
    }

 

    useEffect(()=>{
       dispatch(get_province_rules())
    },[])
    return (
        <div className="container mt-4">
            <div className="d-flex justify-content-between align-items-center mb-5">
                <h2 className="mb-0">Province Rules Management</h2>
                <button 
                    className="btn btn-primary"
                    style={{ minWidth: 160 }}
                    onClick={() => setOpen(true)}
                >
                    <i className="bi bi-plus-lg me-2"></i> Add New Rule
                </button>
            </div>

            <div className="table-responsive">
                <table className="table table-striped table-hover align-middle">
                    <thead className="table-primary">
                        <tr>
                            <th>ID</th>
                            <th>Province</th>
                            <th>Reg. Body</th>
                            <th>Code</th>
                            <th>Legislation</th>
                            <th>Status</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {rules && rules?.map((rule) => (
                            <tr key={rule.id}>
                                <td>{rule.id}</td>
                                <td>{rule['province.name'] || 'N/A'}</td>
                                <td>{rule.regulatory_body_acronym}</td>
                                <td>{rule['province.code']}</td>
                                <td>{rule.key_legislation}</td>
                                <td>
                                    <span className={`badge ${rule['province.is_active'] ? 'bg-success' : 'bg-primary'}`}>
                                        Active
                                    </span>
                                </td>
                                <td>
                                    <button 
                                        className="btn btn-sm btn-info me-2 text-white"
                                        onClick={() => handleView(rule)}
                                    >
                                        <i className="bi bi-eye"></i> View
                                    </button>
                                    <button 
                                        className="btn btn-sm btn-warning text-white"
                                        onClick={() => handleEdit(rule)}
                                    >
                                        <i className="bi bi-pencil"></i> Edit
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {/* View Modal */}
            {viewModal && selectedRule && (
             <RulesDetails selectedRule={selectedRule} closeModals={closeModals} />
            )}

            {/* Edit Modal */}
            {editModal && (
                <>
                 <EditRule closeModals={closeModals} formData={formData} />
                </>
            )}
            {/** add modal */}
            {openAdd && (
                <>
                <AddProvinceRule closeModals={closeModals} />
                </>
            )}
        </div>
    )
}

export default ListProvinceRules